<!--搜索筛选-->
<template>
  <div class="screen-warp">
    <screen
      ref="screen"
      :clickUpate="true"
      :showBtns="false"
      :options="screenOptions"
      @updateOptions="updateOptions"
      @confirm="filterChange"
    ></screen>
  </div>
</template>

<script>
import screen from '@components/screen/';

export default {
  components: {
    screen,
  },
  props: {
    screenOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      timer: null,
    };
  },
  methods: {
    // 筛选改变
    filterChange(index, arr) {
      const key = this.screenOptions[index].key;
      let temp;
      if (index === 0) {
        // 地区筛选
        if (arr.length) {
          temp = arr.map(item => item.id).join(',');
        }
      } else {
        // 排序
        temp = arr[0].id;
      }
      this.$emit('change', key, temp);
    },
    // 更新screen options
    updateOptions(key, index, val) {
      this.screenOptions[index][key] = val;
    },
  },
};
</script>

<style lang="less" scoped>
.screen-warp {
  background: #fff;
  box-shadow: inset 0 -1px 0 0 rgba(0, 0, 0, 0.08);
}
</style>
